module.exports = __webpack_public_path__ + "img/quienes4.35ae6f32.jpg";